import './WatchAttributesViewer.less';
import React, {useState, useEffect} from 'react';
import {
    img__watch_crystal, img__watch_features,
    img__watch_material,
    img__watch_movement,
    img__watch_projection_main,
    img__watch_projection_side, img__watch_water_resistance, img__watch_water_resistant
} from "../../../globalConfig";
import {
    REFERENCE_KEY_WATCH_LUG_WIDTH,
    REFERENCE_KEY_WATCH_LUGS_DISTANCE,
    REFERENCE_KEY_WATCH_CASE_DIAMETER,
    REFERENCE_KEY_WATCH_CASE_THICKNESS,
    REFERENCE_KEY_WATCH_CASE_MATERIAL,
    REFERENCE_KEY_WATCH_MOVEMENT_TYPE,
    REFERENCE_KEY_WATCH_CRYSTAL,
    REFERENCE_KEY_WATCH_WATER_RESISTANCE,
    REFERENCE_KEY_WATCH_FEATURES,
} from "../../../model-constants/product-attribute-group/referenceKeys";
import __ from '../../../i18n';

const refKeys = [
    REFERENCE_KEY_WATCH_LUG_WIDTH,
    REFERENCE_KEY_WATCH_LUGS_DISTANCE,
    REFERENCE_KEY_WATCH_CASE_DIAMETER,
    REFERENCE_KEY_WATCH_CASE_THICKNESS,
    REFERENCE_KEY_WATCH_CASE_MATERIAL,
    REFERENCE_KEY_WATCH_MOVEMENT_TYPE,
    REFERENCE_KEY_WATCH_CRYSTAL,
    REFERENCE_KEY_WATCH_WATER_RESISTANCE,
    REFERENCE_KEY_WATCH_FEATURES,
];

export default function WatchAttributesViewer({attributes, groups}) {

    const find = (referenceKey, multi = false) => {
        const group = groups.find(t => t.reference_key === referenceKey);

        if (!group) {
            return null;
        }

        const attrs = attributes.filter(t => t.group_id === group.id);

        return {
            name: group.name,
            value: multi
                ? attrs.map(t => t.name)
                : attrs.length > 0 ? attrs[0].name : null
        };
    };

    const caseDiameter = find(REFERENCE_KEY_WATCH_CASE_DIAMETER);
    const caseThickness = find(REFERENCE_KEY_WATCH_CASE_THICKNESS);
    const lugWidth = find(REFERENCE_KEY_WATCH_LUG_WIDTH);
    const lugsDistance = find(REFERENCE_KEY_WATCH_LUGS_DISTANCE);
    const caseMaterial = find(REFERENCE_KEY_WATCH_CASE_MATERIAL);
    const movementType = find(REFERENCE_KEY_WATCH_MOVEMENT_TYPE);
    const crystal = find(REFERENCE_KEY_WATCH_CRYSTAL);
    const waterResistance = find(REFERENCE_KEY_WATCH_WATER_RESISTANCE);
    const features = find(REFERENCE_KEY_WATCH_FEATURES, true);

    return <div className="watch-attributes-viewer">
        <div className="dimensions-col">
            <div className={'main-projection' + (lugsDistance !== null ? ' has-lug-to-lug' : '')}>
                {
                    caseDiameter !== null &&
                    <div className="left">
                        <div className="case-diameter">
                            <div className="text">
                                <span aria-label={caseDiameter.name}>{caseDiameter.value}</span>
                            </div>
                            <div className="rule"/>
                            <div className="aligns"/>
                        </div>
                    </div>
                }
                <div className="center">
                    {
                        lugsDistance !== null &&
                        <div className="lug-to-lug">
                            <div className="text">
                                <span aria-label={lugsDistance.name}>{lugsDistance.value}</span>
                            </div>
                            <div className="rule"/>
                            <div className="aligns"/>
                        </div>
                    }
                    <img src={img__watch_projection_main}/>
                </div>
                {
                    lugWidth !== null &&
                    <div className="right">
                        <div className="lug-width">
                            <div className="rule"/>
                            <div className="text">
                                <span aria-label={lugWidth.name}>{lugWidth.value}</span>
                            </div>
                        </div>
                    </div>
                }
            </div>
            <div className={'side-projection' + (caseDiameter !== null ? ' has-case-diameter' : '')}>
                <div className="center">
                    {
                        caseDiameter !== null &&
                        <div className="case-diameter">
                            <div className="text">
                                <span aria-label={caseDiameter.name}>{caseDiameter.value}</span>
                            </div>
                            <div className="rule"/>
                            <div className="aligns"/>
                        </div>
                    }
                    <img src={img__watch_projection_side}/>
                </div>
                <div className="right">
                    {
                        caseThickness !== null &&
                        <div className="case-thickness">
                            <div className="aligns"/>
                            <div className="rule"/>
                            <div className="text">
                                <span aria-label={caseThickness.name}>{caseThickness.value}</span>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
        <div className="miscellaneous-col">
            {
                [
                    [caseMaterial, img__watch_material],
                    [movementType, img__watch_movement],
                    [crystal, img__watch_crystal],
                    [waterResistance, img__watch_water_resistance],
                    [features, img__watch_features],
                ]
                    .filter(([attr]) => attr !== null)
                    .map(([attr, imgUrl]) => (
                    <div className="attribute-item" key={attr.name}>
                        <img src={imgUrl}/>
                        <div className="attribute">
                            <div className="name">{attr.name}</div>
                            {
                                (attr.value instanceof Array ? attr.value : [attr.value])
                                    .map(value => (
                                        <div className="value" key={value}>
                                            {value}
                                        </div>
                                    ))
                            }
                        </div>
                    </div>
                ))
            }
        </div>
    </div>;
}
